import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import {
  importProvidersFrom,
  isDevMode,
  provideCheckNoChangesConfig,
  provideZonelessChangeDetection
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { MsalModule } from '@azure/msal-angular';
import { HttpModule } from '@bbraun/helpex/src/lib/http';
import { provideTransloco } from '@jsverse/transloco';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { HeaderInterceptor } from '@shared/interceptors/https.interceptor';
import {
  MSAL_PROVIDERS,
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory
} from '@shared/service/auth/app-msal-factory.config';
import { ApplicationEffects } from '@store/application/application.effects';
import { EntitiesEffects } from '@store/entities/entities.effects';
import { ProductManagersEffects } from '@store/product-managers/product-managers.effects';
import { SystemNotificationsEffects } from '@store/system-notifications/system-notifications.effects';
import { UserFacade } from '@store/user/user.facade';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routing';
import { AdminGuard } from './app/guards/admin.guard';
import { TranslocoHttpLoader } from './app/i18n/transloco-http-loader';
import { reducers } from './app/store';

// Angular's production mode is enabled by the CLI via the `optimization` build
// option (see the "staging" and "production" configurations in angular.json),
// so calling enableProdMode() here is neither necessary nor recommended.

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    // Development only: periodically re-runs `checkNoChanges` over all views. This
    // surfaces state that was changed without notifying Angular - the class of bug
    // zone.js used to hide by re-running change detection on every async task.
    ...(isDevMode() ? [provideCheckNoChangesConfig({ interval: 1000, exhaustive: true })] : []),
    MSAL_PROVIDERS,
    importProvidersFrom(
      MsalModule.forRoot(
        MSALInstanceFactory(),
        MSALGuardConfigFactory(),
        MSALInterceptorConfigFactory()
      ),
      HttpModule
    ),
    provideStore(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictStateSerializability: true,
        strictActionSerializability: true
      }
    }),
    provideEffects([
      ApplicationEffects,
      ProductManagersEffects,
      SystemNotificationsEffects,
      EntitiesEffects
    ]),
    AdminGuard,
    UserFacade,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideRouter(routes),
    provideTransloco({
      config: {
        availableLangs: ['en', 'de'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        // Do not use environment here, as it will be replaced by the Angular CLI
        // during build time. Instead, use isDevMode() to determine if the app is
        // running in development mode.
        prodMode: !isDevMode()
      },
      loader: TranslocoHttpLoader
    })
  ]
}).catch((err) => console.error(err));
